export default __webpack_public_path__ + "static/media/ic_ltc_24.10d8d555.svg";